import React, { useState } from "react";
import "./addVideoLocationModal.css";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NarrowInputField from "../../components/input/new/narrowInputField";
import NarrowDropdown2 from "../../components/input/new/narrowDropdown2";
import RadioButton from "../../components/input/new/radioButton";

const AddVideoLocationModal = ({ isOpen, onClose, onAddLocation }) => {
  const [locationName, setLocationName] = useState("");
  const [state, setState] = useState("");
  const [video, setVideo] = useState("");
  const [contactName, setContactName] = useState("");
  const [notifEmail, setNotifEmail] = useState("");
  const [notifPhone, setNotifPhone] = useState("");

  const handleSubmit = (e) => {
    // Handle form submission logic here
    e.preventDefault();
    
    // Validate that we have a location name
    if (!locationName || locationName.trim() === '') {
      alert("Please provide a location name.");
      return;
    }

    const newLocation = {
      name: locationName.trim(),
      platform: video,
      state: state,
      contactName: contactName,
      notifEmail: notifEmail,
      notifPhone: notifPhone,
    };
    onAddLocation(newLocation);
    resetFields(); // Clear all fields after adding a location
  };

  const resetFields = () => {
    setLocationName("");
    setState("");
    setVideo("");
    setContactName("");
    setNotifEmail("");
    setNotifPhone("");
  };

  const usaStates = [
    { label: "Alabama", value: "AL" },
    { label: "Alaska", value: "AK" },
    { label: "Arizona", value: "AZ" },
    { label: "Arkansas", value: "AR" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "Delaware", value: "DE" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Hawaii", value: "HI" },
    { label: "Idaho", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Iowa", value: "IA" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Maine", value: "ME" },
    { label: "Maryland", value: "MD" },
    { label: "Massachusetts", value: "MA" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Mississippi", value: "MS" },
    { label: "Missouri", value: "MO" },
    { label: "Montana", value: "MT" },
    { label: "Nebraska", value: "NE" },
    { label: "Nevada", value: "NV" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "New York", value: "NY" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Vermont", value: "VT" },
    { label: "Virginia", value: "VA" },
    { label: "Washington", value: "WA" },
    { label: "West Virginia", value: "WV" },
    { label: "Wisconsin", value: "WI" },
    { label: "Wyoming", value: "WY" },
  ];

  const handleCancel = () => {
    resetFields(); // Clear all fields when closing the modal
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="video-location-modal-overlay">
      <div className="video-location-modal-content">
        <div className="video-modal-header">
          <h2 className="video-locations-modal-title">Add video location</h2>
          <IconButton onClick={onClose} className="video-close-modal-btn">
            <CloseIcon />
          </IconButton>
        </div>

        <div className="video-modal-body">
          <NarrowInputField
            name="Location Name"
            title="Location Name"
            placeholder="Location Name"
            isRequired={true}
            value={locationName}
            onChange={(e) => setLocationName(e.target.value)}
            halfWidth={false}
          />

          <NarrowDropdown2
            title="Select the states you are licensed in"
            placeholder="Select one"
            items={usaStates} // You can provide states or licenses here
            isRequired={true}
            value={state}
            onChange={(e) => {
              setState(e);
            }}
            multiple={false}
            halfWidth={false}
          />

          <div style={{ marginBottom: "2rem" }} />

          <div className="video-locations-radio-row">
            <p className="row-title"> Video service platform </p>
            <p className="locations-gray-subtitle">
              What service do you use to conduct video visits?
            </p>
            <div style={{ height: "1.5rem" }} />

            <RadioButton
              label="Quidpro video service"
              name="quidpro"
              value="quidpro"
              checked={video === "quidpro"}
              onChange={(e) => setVideo(e.target.value)}
            />
            <RadioButton
              label="Third party video service"
              name="thirdparty"
              value="thirdparty"
              checked={video === "thirdparty"}
              onChange={(e) => setVideo(e.target.value)}
            />
          </div>
          <div style={{ height: "1rem" }} />

          <NarrowInputField
            name="Contact person"
            title="Name of contact person (optional)"
            subLabel="This will not be visible to the public"
            placeholder="John Appleseed"
            isRequired={false}
            value={contactName}
            onChange={(e) => setContactName(e.target.value)}
            halfWidth={false}
          />

          <NarrowInputField
            name="Contact Email"
            title="Email for appointment notifcations (optional)"
            subLabel="This will not be visible to the public"
            placeholder="john@quidpro.ai"
            isRequired={false}
            value={notifEmail}
            onChange={(e) => setNotifEmail(e.target.value)}
            halfWidth={false}
          />

          <NarrowInputField
            name="Contact Phone"
            title="Contact phone number (optional)"
            placeholder="() -"
            isRequired={false}
            value={notifPhone}
            onChange={(e) => setNotifPhone(e.target.value)}
            halfWidth={false}
          />

          <hr
            className="h-rule"
            style={{ width: "100%", marginTop: "20px", marginBottom: "20px" }}
          />

          <div className="video-modal-actions">
            <button className="locations-cancel-button" onClick={handleCancel}>
              Cancel
            </button>

            <button
              className="video-locations-submit-button"
              onClick={handleSubmit}
            >
              Add location
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVideoLocationModal;
